import { render, staticRenderFns } from "./JzzDashCartridgeUsage.vue?vue&type=template&id=50f67789&scoped=true"
import script from "./JzzDashCartridgeUsage.vue?vue&type=script&lang=js"
export * from "./JzzDashCartridgeUsage.vue?vue&type=script&lang=js"
import style0 from "./JzzDashCartridgeUsage.vue?vue&type=style&index=0&id=50f67789&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f67789",
  null
  
)

export default component.exports